// extracted by mini-css-extract-plugin
export default {"root":"render-value_root__fpWA5","fraction":"render-value_fraction__Rbdpw","currency":"render-value_currency__eHf-w","placeHolderShimmer":"render-value_placeHolderShimmer__Cj9eb"};